import { useSelector } from "react-redux";
import classes from "./Average.module.css"

const Average = ({ averageSubmission, averageScore, averageList }) => {

    const texts = useSelector((state) => state.translate.texts);
    return (
        <>
            <div className={classes.AvergeTable}>
                <div className={classes.AvergeScoreText} >{texts.SubmissionPercentage}</div>
                <div className={`${classes.AvergeAvergeScore} ${averageSubmission && classes.ShowAvergeScore}`}  > {averageSubmission}</div>
                {averageList && averageList.map((s, index) =>
                    <div key={index} className={`${classes.AvergeScore} ${s.AvgSubmissions
                        && classes.ShowScore}`}>
                        {s.AvgSubmissions> 0 && Math.round(s.AvgSubmissions*100)}%
                    </div>
                )}
            </div>
            <div className={classes.AvergeTable}>
                <div className={classes.AvergeScoreText} >{texts.ScorePercentage}</div>
                <div className={`${classes.AvergeAvergeScore} ${averageScore && classes.ShowAvergeScore}`} >{averageScore}</div>
                {averageList && averageList.map((s, index) =>
                    <div key={index} className={`${classes.AvergeScore} ${s.avgScore && classes.ShowScore}`}>
                        {Math.round(s.avgScore * 100)}
                    </div>
                )}
            </div>
        </>
    )
}
export default Average